export default {
  meeting:{
    applyrecurring: '更改将应用于新的循环日程，历史会议不会受到影响。',
    recurrenceDescribeTwo: '从{start}开始，直到{end}，每{loopPulse}周的{week}重复一次',
    wanttodeletethemeetingfollowTwo: '删除当前选中会议及其后续循环会议？',

    loopCycleSelectTips: '请选择每周周几重复',

    export: '导出',
    exportMeetingFileFuncTipsTitle: '导出提示',
    exportMeetingFileFuncTipsContentOne: '当前未设置筛选条件，将默认导出本年度的会议数据。',
    exportMeetingFileFuncTipsContentTwo: '如需导出其他时间段的会议数据，请先设置筛选条件后再导出。',

    myMeetingSearch: '我的会议',
    meetingTimeSearch: '会议时间',
    meetingRoomsSearch: '会议室',

    Recurring: '重复：',
    wanttodeletethemeetingfollow: '确定要删除此会议及后续所有会议吗？',

    endTimeCannotBeforeBeginTime: '结束日期不能早于开始日期',
    Thismeeting: '本次会议',
    Recurringmeeting: '周期会议',
    Checkin: '签到：',
    checkinTip: '启用后，与会者可以扫描会议室预约二维码进行签到。',
    Recurrence_Setrecurrence: '设置重复',
    Recurrence_Start: '开始',
    Recurrence_RepeatEvery: '重复间隔',
    Recurrence_Week: '周',
    Recurrence_end: '结束',
    recurrenceDescribe: '每{week}重复一次，从{start}开始，直到{end}',
    Recurrence_DoesnotRepeat: '不重复',
    Recurrence_Weekly: '每周',

    AddressBookUser: '用户',
    AddressBookPhonebook: '通讯录',

    RoomByPeopleNum1: '2人及以下',
    RoomByPeopleNum2: '3-6人',
    RoomByPeopleNum3: '7-10人',
    RoomByPeopleNum4: '11-15人',
    RoomByPeopleNum5: '16-20人',
    RoomByPeopleNum6: '21-30人',
    RoomByPeopleNum7: '30人以上',

    whoAreBound:'已绑定系统账号的人员，将在系统日程中看到该会议。填写邮箱的人员，将通过邮件收到会议通知。如需接收邮件通知，可前往【个人资料】中完善邮箱信息。',

    AttendessMeeting:'参会人：',
    SelectAttendessMeetingTip:'选择参会人',

    MeetingFilter: '会议筛选',
    HostedbyMe:'我发起的',
    Invitedby:'我参与的',
    Otherby:'其它',

    AddressIsDuplicated:'联系人邮箱重复',
    meetingExpired:'已过期',
    titlePhoneFormat: '电话只能填写数字和()+，-',
    selectField: '请选择文件',
    Limit255: '文件名不允许超过255个字符',
    "nameLimit25": "名字不能超过25个字符",
    "emailLimit50": "邮箱不能超过50个字符",
    "emailFormatError": "请输入正确的邮箱格式",
    "phoneLimit11": "电话号码最多只能输入11位数字",
    ParticipantsEmail:'参会人邮箱：',
    listIsEmpty:'列表为空',
    Startimporting:'开始上传',
    Selectfile:'选择文件',
    Importfile:'导入文件',
    ImportfileTip:'*仅支持导入 Outlook 格式的 CSV（.csv）或 vCard（.vcf）格式文件。',
    addParticipants:'添加参会人',
    multiselectdeselect:'删除标签提示',
    multiselectselected:'已选提示',
    enterOrSelectALabel:'选择参会人邮箱',
    deleTitleContact:'确定删除联系人吗？',
    delTitleContactContent:'删除联系人?',
    deleteContactTitle:'请选择要删除的联系人',
    editcontact:'编辑联系人',
    Name:'名字',
    email:'邮箱',
    telephoneNumber:'电话',
    Addcontact:'添加联系人',
    Importcontactfile:'导入联系人',
    AddressBook:'通讯录',
    Participants:'参与会议者：',

    bindTipContent:'当前组织已绑定第三方日历，请前往Outlook/Teams预定会议',
    Productupdatenews:'有新版本更新发布',
    bookingPerson:'预定人',
    DeleteMeeting:'删除会议',
    wanttodeletethemeeting:'是否删除会议',
    hasbeendeleted:'会议已删除',
    theMeetingWasAborted:'提前结束会议',
    theMeetingWasAbortedContent:'是否提前结束会议',
    determineTheAbortTask:'提前结束会议',
    theMeetingEndedEarly:'会议已提前结束',
    with:'与',
    Other:'等',
    tasks:'个任务',
    conflict:'冲突',
    meetConflicts:'以下会议时间冲突：',
    itIsNotAllowedToSelectThePastTime:'不允许选择过去的时间',
    selected:'已选择',
    noOverFive:'选择的会议室不能超过5个',
    approvalOpinions:'审批意见',
    beyondTheTimeLimitItCannotBeSelected:'超过时间不可选择',
    startMonth:'开始月份',
    to:'至',
    stopMonth:'结束月份',
    didnTStart:'未开始',
    ONGOING:'进行中',
    ENDED:'已结束',
    hasBeen:'已被',
    booking:'预定',
    Approval:'需审批',
    MeetingRoom:'会议室',
    AllRoom:'全部会议室',
    Available:'可预订',
    Initiate:'发起会议',
    MeetingApproval:'会议审批',
    PreviousMonth:'上个⽉',
    Today:'今天',
    NextMonth:'下个⽉',
    YearMonth:'年/⽉',
    TimeDisplay:'时刻显示',
    MeetingTitleAbbreviation:'会议标题缩写',
    InitiateMeeting:'发起会议',
    PendingMeetings:'待参加会议',
    AllMeetings:'全部会议',
    noMeetings:'暂无待参加的会议',
    NotStarted:'未开始',
    Organizer:'组织⼈',
    MeetingDateTime:'会议时间',
    MeetingLocation:'会议地点',
    MeetingSubject:'会议主题',
    Invited:'邀请⼈数',
    PeopleAccepted:'⼈员接受情况',
    EditMeeting:'修改会议',
    CancelMeeting:'取消会议',
    InitiateEditMeeting:'发起/编辑会议',
    Subject:'主题',
    Presenter:'主讲⼈ ： ',
    DateTime:'⽇期和时间',
    TimeAndZone:'时区',
    Attendees:'参加者',
    Addrequiredattendees:'添加必需的参加者',
    SelectRooms:'选择会议室',
    Reminder:'提醒',
    Remindbeforestart:'开始前提醒',
    Confirm:'确认',
    topic:'主题 : ',
    topicplace:'新的会议名称',
    speaker:'主讲人：',
    speakerplace:'请输入主讲人信息',
    DateAndTime:'⽇期和时间：',
    TimeZone:'时区',
    EndDate:'End date',
    Rooms:'会议室： ',
    Notes:'备注： ',
    MeetingRoomApproval:'会议室审批',
    PendingApproval:'待审批',
    Approved:'已审批',
    nopendingapprovals:'暂无待处理的审批单',
    Applicant:'申请⼈',
    UsageTime:'使⽤时间',
    ApprovalResult:'审批结果',
    ApprovalComments:'审批意⻅',
    Approve:'通过',
    Reject:'拒绝',
    Search:'搜索',
    Filter:'筛选',
    scanTheQRCodeToSignIn:'扫码签到',
  },
  NPS:{
    Relay:'继电器',
    RelaySettings:'继电器设置',
    DevicePower:'设备电源控制',
    DeviceElevation:'升降控制',
    LinageWithNPSPower:'与NPS电源的联动',
    PresentationSwitch:'演示切换',
    Duplicate:'复制',
    LinkagewithNPSPowe:'与NPS电源联动',
    npsTooltip:'只有将 PC 主机切换到 HDMI OUT 1 才能调用 USB 设备',
    nmpTooltip:'点击“复制”按钮可将屏幕内容复制至其他显示器，使显示效果同步显示在多个屏幕上。',
  },
  textTemplate:{
    template2513:'火警应急广播',
    template2514:'请大家根据撤离示意图，从安全出口通道、消防通道疏散到安全地方。',
    moreTemplate:'模板已达上限',
    add:'添加',
    SetTemplate:'预设模板',
    Emergency:'应急',
    General:'普通',
    BroadcastDevices:'播放设备：',
    selectBroadcastDevices:'请选择播放设备',
    All:'全部',
    AddTemplate:'添加模板',
    EditTemplate:'编辑模板',
    deleteTemplage:'确定要删除选中的模板吗？',
    title:'删除模板',
    selectTemplage:'请选中模板！',
    DeleteCancelled:'已取消删除！',
    DeletedSuccessfully:'删除成功！',
    noData:'暂无模板可使用，点击右上角可添加模板',
    TemplateTitle:'模板标题：',
    BroadcastType:'播放类型：',
    BroadcastTypeDialog:'播放类型：',
    selectBroadcastType:'请选择播放类型',
    BroadcastDuration:'广播时长：',
    BroadcastDevice:'播放设备：',
    BroadcastContent:'播放内容：',
  },
  common:{
    mediaTimeStateNotifyErrorTitle: '出错了！',
    mediaTimeStateNotifyErrorContent: '您的流媒体服务已到期，请联系您的代理商及时续费。',
    mediaTimeStateNotifyWarnTitle: '请注意！',
    mediaTimeStateNotifyWarnContent: '您当前为流媒体服务试用状态，最多只可向三台终端设备发送广播命令，请检查您勾选的设备数量。',
    mediaTimeStateNotifySuccessTitle: '续费成功',
    mediaTimeStateNotifySuccessContent: '您的流媒体服务已经可以正常使用。谢谢。',
    company:'公司：',
    tableAddress:'地址：',
    createTime:'创建时间：',
    email:'邮箱：',
    phone:'电话：',
    Trial:'试用',
    TrialWorkstation:'您当前为流媒体服务试用状态。最多只可向三台终端设备发送广播命令。',
    Normal:'正常',
    NormalWorkstation:'您的流媒体服务的有效期为',
    to:'至',
    Advent:'临期',
    AdventWorkstationOne:'您的流媒体服务即将于',
    AdventWorkstationTwo:'到期，请及时联系您的代理商续费以免影响正常使用。',
    Expired:'逾期',
    ExpiredWorkstation:'您的流媒体服务已到期，请联系您的代理商及时续费。',
  },
  route: {
    dashboard: '管理后台',
    i18n: 'I18n',
    Devices:'设备控制',
    Broadcast:'广播控制',
    Schedule:'日程任务',
    Resources:'存储管理',
    Live:'直播控制',
    meetings:'会议预约',
  },
  navbar: {
    updates:'版本更新',
    logOut: '退出登录',
    screenfull: '全屏',
    oprofile:'个人资料',
    settings:'设置',
    language:'语言',
    BackTianwa:'返回天蛙云',
    newUserGuide:'新用户指引',
  },
  feedback:{
    Feedback:'意见反馈',
    email:'请留下邮箱以便我们快速反馈',
    content:'欢迎留言帮助我们更好地改进产品，感谢您的意见和建议。',
    submit:'提交',
    emailNoEmpty:'邮箱不能为空',
    emailTrueRule:'请输入正确格式的邮箱',
    contentNoEmpty:'内容不能为空',
    feedbackSuccess:'反馈成功',
    feedbackFailed:'反馈失败',
    emailNoChinese:'邮箱不能有汉字',
    emailLength:'长度在 5 到 50 个字符',
    emailSpecialString:'邮箱不能包含特殊字符串'
  },
  home:{
    btnDevices:'设备控制',
    btnRoadcast:'广播控制',
    btnResources:'存储管理',
    btnLive:'直播控制',
    meetings:'会议预约',
    todaySchedule:'今日任务日程',
    allSkedules:'所有日程',
    details:'查看详情',
    btnStart:'开始',
    titleContent:'你好，欢迎使用Q-NEX工作台。接下来请跟随新手指引了解我们',
    btnExit:'退出指引',
  },
  login: {
    checkPasswordTitleTwo:"请设置 6 位及以上的密码，需包含字母和数字，可使用特殊符号（不限制）",
    captcha:'验证码',
    checkPasswordTitle:'密码至少6位且不能为纯数字',
    title: '欢迎回来',
    logIn: '登录',
    consoleLogin:'请登录',
    username: '登录名',
    password: '密码',
    any: 'any',
    thirdparty: '其他登陆方式',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !',
    placeholder:["用户名","密码","验证码"],
    userNameTitle:'用户名不符合要求!',
    forget:'忘记密码',
    loginTitle0:'登录成功!',
    loginTitle1000:'用户名或密码错误!',
    loginTitle1001:'用户名、密码不能为空!',
    loginTitle1002:'验收码不能为空!',
    loginTitle1003:'用户名状态非法，登录失败!',
    loginTitle1004:'验证码错误!',
    loginTitle1005:'未登陆，请先登陆!',
    loginTitle1006:'两次输入的密码不一致!',
    loginTitleUserName:'用户名不能为空!',
    loginTitlePwd:'密码不能为空!',
    loginTitleVercode:'验证码不能为空!',
    titleLoginNameFormat:'账号格式只能输入字母和数字',
    privacy:'Q-NEX 用户隐私政策',
    privacyContent:"同意",
    '_zh':'中文(简体)',
    '_en':'_English',
    '_ko':'한국어',
    '_zh_ft':'中文(繁體)'
  },
  devices:{
    ptzCamera:'PTZ摄像头',
    start:'开始',
    stop:'停止',
    nmpPowerOff_mandatory:'NMP正在进行强制广播',
    nmpPowerOff_nomandatory:'正在进行非强制广播，是否执行？',
    nmpsPowerOff_mandatory:'当前有NMP设备正在进行强制广播',
    nmpsPowerOff_nomandatory:'当前有NMP设备正在进行非强制广播',
    reset:'重置',
    displayedInTheControlArea:'显示在控制区',
    dragOrder:'拖动排列顺序',
    areaSettingTwoNotice:'*RS232控制、空调控制、智能遥控根据后台绑定情况判断是否在控制区显示',
    areaSettingThreeNotice:'*CBX的设备控制根据后台绑定情况判断是否在控制区显示',
    controlSet:'控制区设置',
    vcbNoLine:'暂无CBX设备在线',
    vcbNoBound:'暂无绑定CBX设备',
    tscNoBound:'TSC的RS232尚未绑定任何数据，请通知管理员前往管理后台绑定。',
    light:'电源控制',
    vcbpower:'电源',
    rs232Control:'串口控制',
    CBX:{
      powerSupplyON:'电源ON',
      powerSupplyOFF:'电源OFF',
      lockScreenON:'锁屏ON',
      lockScreenOFF:'锁屏OFF',
      childLockON:'童锁ON',
      childLockOFF:'童锁OFF',
      energySavingON:'节能ON',
      energySavingOFF:'节能OFF',
      signalSourceSwitchingON:'OPS',
      signalSourceSwitchingOFF:'Android',
      volumeAdjustment:'音量调节',
      brightAdjustment:'亮度调节',
      other:'其他...',
    },
    InterfaceOne:'接口一',
    InterfaceTwo:'接口二',
    abcStyleP:'抱歉，TSC和(NMP，MBX，NPS，NDP100，NDP500)不能同时选择',
    masterControl:'主控制',
    powerSupply:'电源',
    RecordingControl:'录播控制',
    RecordingControlSystem:'录播系统',
    LiquidCrystal:'液晶',
    projector:'投影仪',
    othertype:'其他',
    lockScreen:'锁屏',
    childLock:'童锁',
    energySaving:'节能',
    signalSourceSwitching:'信号源切换',
    volumeAdjustment:'音量调节',
    brightAdjustment:'亮度调节',
    other:'其他',
    otherFunction:'功能',
    send:'发送',
    ON:'ON',
    OFF:'OFF',
    '_POWERA':'Display Power',
    '_POWERB':'External Power',
    '_MAGNETICLOCK':'电子锁',
    '_HDMI1':'HDMI in 1',
    '_HDMI2':'HDMI in 2',
    '_HDMI3':'HDMI in 3',
    '_HDMIA':'HDMI out A',
    '_HDMIB':'HDMI out B',
    '_HDMIC':'HDMI out C',
    '_AIR':'空调',

    titleDevices:'按组织筛选:',
    content:'搜索',
    selectALL:'全选',
    SelectRecentPage:'全选本页',
    controlPanel:'控制区',
    displayInputSwitch:'视频输入切换',
    chooseINPUTSources:'选择输入源',
    speakerVolume:'音频音量',
    bass:'低音',
    treble:'高音',
    MICVolume:'麦克风音量',
    AirConditioning:'空调',
    model:'模式',
    setTemp:'温度',
    fanSpeed:'风速',
    bold:'扫风',
    projectionScreen:'投影幕布',
    electronicLock:'电子锁',
    electronicLock1:'电子锁',
    selectDevices:'请选择至少一个设备',
    isCompelType:"该设备强制广播不能进行设备控制！",
    mainPower:'总开关',
    extraPower:'电源控制',
    power:"主电源",
    hdmiBroadcast:'广播',
    equipmentState1:'开机',
    equipmentState2:'关机',
    equipmentState3:'离线',
    main:'主控制',
    external:'外接设备',
    ProjectionScreen:'升降控制',
    UP:'升',
    DOWN:'降',
    LOCK:'锁定',
    UNLOCK:'开锁',
    PleaseDevice:'请选择至少一台设备',
    RemoteControl:'智能遥控',
    Action:'执行',
    Devicefilter:'设备筛选',
    DeviceStatus:'设备状态',
    DeviceType:'类型',
    currentAudioSource:'当前音频源',
    audioSwitching:'音频切换'
  },
  broadcast:{
    isBoarding:'（正在广播中）',
    last3Days:'最近3天',
    last7Days:'最近7天',
    last30Days:'最近30天',
    historyRecord:'历史记录',
    SelectDestination:'1.选择广播目的地',
    BroadcastingConsole:'2.广播设置',
    Notification:'文字广播',
    btnStop:'停止',
    btnStart:'开始',
    Letters60:'(60字以内)',
    Letters300:'(300字以内)',
    LastingTime:'广播时长:',
    Title:'标题:',
    Content:'内容:',
    Cannotquit:'强制广播',
    ChooseMedia:'选择多媒体文件',
    Broadcasting:'媒体广播',
    dialogTitle:'音视频资源',
    SortBy:'排序',
    btnBake:'返回上级',
    cancel: '取消',
    confirm: '确认',
    save:'保存',
    coxAll:'全选',
    PublicCloud:'公共盘',
    IndividualCloud:'个人盘',
    selFile:'请选择播放文件或班级',
    StopBroadcast:'停止广播',
    StartBroadcasting:'开始广播',
    StopBroadcasting:'停止广播',
    ForceQuit:'强制停止',
    PleaseMediaFile:'请选择播放文件',
    PleaseDevice:'请选择播放目的设备',
    broadcast_0:'开始广播',
    broadcast_2500:'超出最大当前工作站最大可连接设备数',
    broadcast_2501:'播放文件错误',
    broadcast_2502:'播放结束',
    broadcast_2503:'无法获取工作站信息',
    broadcast_2510:'请注意!'+ '您当前为流媒体服务试用状态，最多只可向三台终端设备发送广播命令，请检查您勾选的设备数量。',
    broadcast_2018:'流媒体服务被关闭',
    broadcast_2019:'流媒体服务已过期',
    broadcast_2512:'模板超出上限',
    broadcast_2513:'火警应急广播',
    broadcast_2514:'请大家根据撤离示意图，从安全出口通道、消防通道疏散到安全地方',
    broadcast_2006:'查询不到设备 ',
    broadcast_2: '云盘服务异常',
    broadcast_2515:'选择设备中有未具有广播功能的设备',
    broadcast_2516:'选择的文件，超过NMP最大支持的分辨率',
    broadcast_2517:'选择的文件，超过NDP500最大支持的分辨率',
    broadcast_Title:'设备广播提醒',
    broadcast_TitleNDP500:'NDP500设备广播提醒',
    broadcast_content:'广播支持最高4K@30FPS; 最佳分辨率是1080P@30FPS。',
    broadcast_contentNDP500:'NDP500/600支持最高1080P@30FPS;最佳分辨率为720P@30FPS。',
    broadcast_noSupported:'不支持以下视频广播：',
    broadcast_noSupportedNDP500:'NDP500/600不支持以下视频广播：',
  },
  resources:{
    uploadNameLengthError:'上传文件名称不能超过100个字!',
    onUploadFile:'暂无待上传文件',
    open:'展开',
    fold:'折叠',
    close:'关闭',
    PublicCloud:'公共盘',
    IndividualCloud:'个人盘',
    TransfersHistory:'传输历史',
    btnDownload:'下载',
    btnDelete:'删除',
    btnUploadFile:'上传',
    btnNewFolder:'新文件夹',
    btnBake:' 返回上级',
    coxAll:'全选',
    uploadError:'上传文件大小不能超过1G！',
    MD5:'校验MD5',
    merge:'合并中',
    transcoding:'转码中',
    uploadFailed:'上传失败',
    fileError:'文件读取出错，请检查该文件',
    tableName:'文件名',
    tableSize:'大小',
    tableType:'类型',
    tableTimeAdded:'添加时间',
    tableAction:'操作',
    btnRename:'重命名',
    btnMoveTo:'移动到...',
    ClearAll:'清除全部',
    cancel: '取消',
    confirm: '确认',
    save:'保存',
    addSuccess:'添加成功！',
    addError:'添加失败!',
    editSuccess:'编辑成功！',
    editError:'编辑失败!',
    delSuccess:'删除成功！',
    delError:'删除失败!',
    diskError3000:'已超过云盘总大小，操作失败！',
    diskError3001:'超过公共盘已使用大小，操作失败！',
    diskError3002:'已有用户空间的使用量，已超过设定的大小，操作失败！',
    diskError3003:'查询不到数据，请检查是否已绑定媒体库！',
    diskError3004:'该文件夹名称已存在！',
    diskError3005:'获取文件夹失败！',
    diskError3006:'同一级，创建目录不能超过99个！',
    diskError3007:'存在相同的文件名，修改失败！',
    diskError3008:'存在相同的文件夹名，修改失败！',
    diskError3009:'超过剩余空间大小，上传失败！',
    diskError3010:'上传私有云盘失败！',
    diskError3011:'文件校验失败，请重新上传文件！',
    diskError3012:'获取私有云地址失败，操作失败！',
    diskError3013:'多个文件组合不能超过100M，大文件请单个下载！',
    diskError3014:'压缩失败，请重新选择文件下载！',
    diskError3015:'无权限操作此功能',
    downloadError:'下载失败！',
    mobileError:'移动失败！',
    root:'所有文件',
    Name:'文件名',
    Size:'大小',
    Type:'格式',
    uploadFile:'上传文件',
    newFolder:'新文件夹',
    tableTime:'更新时间',
    permission:'权限不足！',
    notifyTitle:'消息',
    notifyContent:'该用户权限不足无法显示!',
    sortFileName:'文件名',
    sortTime:'按时间',
    sortSize:'按大小',
    sortType:'按类型',
    moveTo:'移动到',
    test:'新文件夹',
    delTitle:'确定删除?',
    delTitleContent:'所选内容将从数据库中删除。该操作无法恢复，你确定要继续吗?',
    delCancelButton:'取消',
    delConfirmButton:'确认',
    // btnMoveTo:'Move to...',
  },
  userMge:{
    userName:'登录名：',
    jobNumber:'工号:',
    email:'邮箱:',
    phone:'电话:',
    group:'组织机构:',
    oldPassword:'旧密码:',
    newPassword:'新密码:',
    confirmNewPassword:'确认新密码:',
    btnSave:'保存修改',
    titleChangePassword:'修改密码',
    titleMyProfile:'个人资料',
    name:'昵称:',
    error1400:'账号(自定义) 已经存在，操作失败!',
    error1401:'账号(系统生成) 已经存在，操作失败!',
    error1402:'学校不存在，导入失败！',
    error1403:'数据存在错误',
    error1404:'权限不足',
    selUser:'请选择用户！',
    error1405:'获取角色失败',
    error1406:'导入的用户信息数据格式不正确',
    error1407:'邮箱 已经存在，操作失败',
    error1408:'电话 已经存在，操作失败',
    editSuccess:'修改成功！',
    ChangePassword:'修改密码',
    UserPrivacyAgreement:'用户隐私协议'
  },
  information:{
    '_2602':' 设备离线',
    '_2603':' 广播失败',
    '_2604':' 广播被切断',
    '_2605':' 云盘空间已满',
    '_2606':' 分钟前',
    '_2607':' 小时前',
    '_2609':' 出现故障,请',
    '_2609_a':' 点击此处',
    '_2609_time':'及时处理',
    userType:'超级管理员',
    unreadNoticeFirst:'未读消息优先',
    sortByTime:'按时间排序',
    coxRead_0:'未读',
    coxRead_1:'已读',
    allCoxRead:'全部标识为已读',
    load:'加载中...',
    noData:'没有更多数据了',
    viewALLMessages:'查看全部消息'
  },
  input:{
    thisField:'此项为必填项.',
    titleShooleNub60:'60字以内',
    titleShooleNub300:'300字以内',
    select:'请选择',
    Offline:'离线'
    // titlRealNameField:''
  },
  schedule:{
    OnlyManual:'仅显示手动任务',
    runStartNow:'立即执行任务',
    runStopNow:'停止任务执行',
    tackExecutionStart:'任务开始执行',
    tackExecutionStop:'任务停止执行',
    dehumidification:'除湿',
    airSupply:'送风',
    masterControl:'主控制：',
    powerSupply:'电源',
    RecordingControl:'录播控制',
    RecordingControlSystem:'录播系统',
    LiquidCrystal:'液晶',
    projector:'投影仪',
    othertype:'其他',
    lockScreen:'锁屏',
    childLock:'童锁',
    energySaving:'节能',
    signalSourceSwitching:'信号源切换',
    other:'其他功能：',
    otherFunction:'功能',
    send:'发送',
    ON:'开',
    OFF:'关',
    btnAddSchedule:'恢复清单',
    EditSchedulelist:'修改任务清单',
    AddSchedulelist:'新建任务清单',
    RestoreSchedulelist:'恢复任务清单',
    btnCancel:'取消',
    btnNewList:'新建清单',
    ListName: '任务清单名称',
    Cannotquit:'强制广播',
    NOCannotquit:'非强制广播',
    ListValidityPeriod: '任务清单有效期',
    ListDescription: '任务清单描述',
    currentSchedule:'现行日程清单',
    historySchedule:'历史日程清单',
    selectTime:'时间:',
    selectTimeTable:'时间',
    taskType:'任务类型:',
    selectBroadcasting:'广播控制',
    selectDeviveControl:'设备控制',
    newSchedule:'新建任务',
    newChecklist:'新建清单',
    titleStatus:'状态',
    titleType:'类型',
    titleStartTime:'开始时间',
    titleEndTime:'结束时间',
    titleRepeat:'重复方式',
    titleName:'任务名称',
    titleAction:'操作',
    tableEnabled:'启用',
    tablePaused:'停止',
    tableEdit:'修改',
    tableDelete:'删除',
    tableVolumeEdit:'广播音量',
    tableBroadcastTitle:'广播标题',
    tableBroadcastContent:'广播内容',
    tableBroadcastList:'广播列表',
    tableBroadcast:'广播方式',
    btnRemoveCompletely:'Remove completely',
    btnEnabled:'启用任务',
    btnPaused:'停用任务',
    btnDelete:'删除',
    repeat0:'周一',
    repeat1:'周二',
    repeat2:'周三',
    repeat3:'周四',
    repeat4:'周五',
    repeat5:'周六',
    repeat6:'周日',
    dialogTitleAdd:'新建设备控制日程',
    dialogTitleEdit:'修改设备控制日程',
    newBroadcastingSchedule:'新建广播任务日程',
    editBroadcastingSchedule:'修改广播任务日程',
    chooseDevice:'选择目标设备',
    timeSetting:'时间设置',
    controlBroadcasting:'广播选项',
    controlOption:'控制选项',
    scheduleName:'任务名称:',
    destination:'目标设备:',
    timeTilte:'开始时间:',
    repeatTitle:'重复选项:',
    dialogRepeat0:'周一',
    dialogRepeat1:'周二',
    dialogRepeat2:'周三',
    dialogRepeat3:'周四',
    dialogRepeat4:'周五',
    dialogRepeat5:'周六',
    dialogRepeat6:'周日',
    dialogOnceType:'一次',
    dialogRepeatType:'多次',
    Manual:'手动',
    ManualContent:'配置完成后，您可以手动执行这些任务。',
    mainPower:'主电源',
    powerControl:'电源控制',
    tableDisplayInputSwitch:'音视频输入切换',
    tableAirConditioning:'空调',
    tableProjectionScreen:'投影幕布',
    tableElectronicLock:'电子锁',
    interactiveFlatPanel:'Interactive Flat Panel',
    displayInputSwitch:'音视频输入切换：',
    speakerVolume:'音频音量',
    MICVolume:'麦克风音量',
    ProjectionScreen:'投影幕布：',
    ElectronicLock:'电子锁：',
    AirConditioning:'空调',
    AirConditioningPower:'电源:',
    AirConditioningModel:'模式:',
    AirConditioningTEMP:'温度:',
    AirConditioningFanSpeed:'风速：',
    OPEN:'开',
    CLOSE:'关',
    UP:'升',
    DOWN:'降',
    PowerOFF:'关',
    PowerON:'开',
    ModelAuto:'自动',
    ModelCool:'制冷',
    ModelHeat:'制热',
    ModelAir:'扫风',
    TEMPLow:'低',
    TEMPMiddle:'中',
    TEMPHigh:'高',
    btnSave:'保存',
    btnNext:'下一步',
    StartTime:'开始时间',
    StopTime:'结束时间',
    Mandatory:'是否强制广播',
    Video:'音视频广播',
    Notification:'文字广播',
    btnFile:'选择媒体文件',
    LastingTime:'Lasting Time',
    textTitle:'标题:',
    textContent:'内容:',
    textTitleLetters:'60字以内',
    textContentLetters:'320字以内',
    CannotquitYES:'是',
    CannotquitNo:'否',
    YES:'YES',
    No:'No',
    delTitleContent:'删除任务清单？',
    delTitleListContent:'删除的任务清单将移动到历史日程清单中，可在历史日程清单中恢复',
    deleListTitle:'删除任务清单？',
    delTitleListContent1:'删除任务清单将导致与其相关的任务都被清除，请确认。',
    deleListTitle1:'确定删除该任务清单？',
    delTitle:'确定删除?',
    btnConfirm:'确认',
    coxAll:'所有任务',
    coxBroadcasting:'广播控制',
    coxDeviveControl:'设备控制',
    rdMandatory:'强制',
    noRdMandatory:'非强制',
    startDate:'开始日期',
    endedDate:'结束日期',
    or:'-',
    broadcastingType:'广播类型',
    ChooseTime:'选择时间',
    ChooseDate:'选择日期',
    newScheduleList:'新建任务清单',
    editScheduleList:'修改任务清单',
    listName:'任务清单名称',
    listValidityPeriod:'任务清单有效期',
    listDescription:'任务清单描述',
    cancel: '取消',
    confirm: '确认',
    save:'保存',
    addSuccess:'添加成功！',
    addError:'添加失败!',
    editSuccess:'编辑成功！',
    editError:'编辑失败!',
    delSuccess:'删除成功！',
    delError:'删除失败!',
    restoreSuccess:'日程清单已恢复',
    restoreError:'日程清单恢复失败',
    restoreTitleContent:'该时间与清单内任务时间冲突，请重新选择',
    Enabled:'启用',
    Paused:'停止',
    Title:'标题:',
    Content:'内容:',
    errorScheduleNameRequired:'任务名称不能为空',
    errorDeviceRequired:'请选择目标设备',
    deleTitle:'确定删除该任务？',
    loopList:'列表循环',
    errorPleaseDateRange:'请选择日期区间',
    'addError_2009':'清单名称重复',
    conflicts:'以下任务时间冲突：',
    Pleaseagain:'请重新输入',
    errorScheduleName:'任务名',
    errorListName:'清单名',
    'today':'今天',
    'yesterday':'昨天',
    'thisWeek':'本周',
    'lastWeek':'上周',
    'lastMonth':'上月',
    'thisMonth':'本月',
    'times':'次数',
    TimeConflicts:'时间冲突',
    'editError_2006':'查询不到设备 ',
    'editError_2010':'任务名称重复',
    'editError_2100':'任务已失效，启动失败。',
    ListTimeExpired:'清单时间已过期，请重新选择',
    TimeExpired:'时间已过期',
    ControlOption:'控制选项未填',
    Pleaseleastone:'请至少选择选择控制选项内容',
    Enter:'请输入内容',
    TitleFilled:'请填写标题',
    ContentFilled:'请填写内容',
    PleaseMediaFile:'请选择文件',
    PleaseSchedule:'请选择要操作任务',
    delTitleScheduleContent:'删除的任务无法恢复',
    deleTitleSchedule:'确定删除任务吗？',
    deleteScheduleTitle:'请选择要删除的任务',
    PleaseFillColumn:'请填写清单名称',
    PleaseDate:'请选择日期',
    Previous:'上一步',
    RemoteControl:'智能遥控',
    taskhasexpired:'此任务已过期，请联系创建人更新时间',
    execute:'执行',
    broadcastingList:'播放列表',
    volumeSuccess:'音量设置成功',
    volumeFailed:'音量设置失败',
  },
  live:{
    StreamingRoom:'直播间',
    btnAddNewRoom:' 新直播间',
    Steaming:'直播中',
    Creater:'主播:',
    Address:'RTMP 地址:',
    StreamingURL:'直播观看地址:',
    DestinationNMP:'选择直播目的设备:',
    stop:'停止',
    stat:'开始直播',
    btnCope:'复制链接',
    QRcode:'二维码',
    Refresh:'重新加载',
    AddNewRoomTitle:'创建新直播间',
    editNewRoomTitle:'修改新直播间',
    roomName:'直播间名:',
    cancel: '取消',
    confirm: '确认',
    save:'保存',
    delTitleContent:'确认要删除该直播间吗? 本操作无法撤回。',
    delTitle:'要删除吗?',
    delConfirmButton:'确认',
    delCancelButton:'取消',
    addSuccess:'添加成功！',
    addError:'添加失败!',
    editSuccess:'编辑成功！',
    editError:'编辑失败!',
    delSuccess:'删除成功！',
    delError:'删除失败!',
    Stopstreaming:'直播开始',
    Startstreaming:'直播停止',
    error2504:'无法获取工作站直播地址',
    error2505:'直播房间名称重复',
    error2506:'直播设备已被其他直播占用',
    error1900:'访问的参数为空',
    error2503:'无法获取工作站信息',
    error2507:'直播地址重复',
    copySuccess:'复制成功',
    copyError:'该浏览器不支持自动复制',
    flashControl:'您尚未安装/运行Flash控件，请安装/运行后再试',
    liveStreaming:'未找到直播视频源，先休息一下',
    btnflash:'安装/运行',
    serverAddress:'服务器地址',
    addressKey:'密钥:',
    watchingAddress:'观看地址',
    audioOnly:'仅音频直播',
    enterTheKey:'密钥不可为空'
  },
  privacy:{
      PrivacyPolicy:'Q-NEX隐私政策',
      Byusing:'您使用 Q-NEX 服务，即表示您信赖我们对您的信息的处理方式。我们深知这项责任事关重大，因此一直致力于保护您的信息，并让您拥有控制权。',
      whatinformation:'本隐私权政策旨在协助您了解我们会收集哪些信息、为什么收集这些信息，以及您如何管理自己的信息。',
      EffectiveDate:'生效日期：2020年1月1日',
      title1:'小奇智联尊重您的隐私',
      title1Respects1:'锐达互动科技股份有限公司及其子品牌小奇智联（统称为“小奇智联”，“ Q-NEX”或“我们”）尊重您的隐私，并了解您的个人数据的处理和安全对您很重要。请查看下面的完整隐私政策，以获取有关我们如何收集，使用，共享和保护您的个人数据的更完整详细信息，以及您在使用和共享您的个人数据方面的选择以及其他重要注意事项。',
      title1Respects2:'本隐私政策解释了Q-NEX在处理（例如收集，使用，存储，复制或披露）您的个人数据方面的做法：（i）通过我们的网站https://www.qnextech.com（“网站”） ，电子邮件，其他书面或亲自交流； （ii）在与客户，最终用户，经销商，分销商，供应商，承包商，代理商或代表的所有商业关系范围内； （iii）在任何其他潜在业务关系的正常情况下。我们承诺遵守法律法规规定的义务，如下所述，包括但不限于《电信和互联网用户个人信息保护规定》，并在我们处理您的个人数据时尊重您的权利。',
      title2:'隐私和数据保护',
      title2Respects1:'“个人数据”是指识别或可用于识别个人的任何信息。',
      title2Respects2:'“隐私和数据保护法”是指在中国境内、以及中国境外任何地方，省，州，联邦或国家级别上与数据隐私，数据安全和/或个人数据保护有关的任何和/或所有法律，规则，指令和法规。其中，中国境外法律法规包括但不限于：（a）通用数据保护条例（GDPR）及其每个欧盟成员国在本国的实施情况； （b）1988年《澳大利亚隐私法》（联邦）和《澳大利亚隐私修正案（增强隐私保护法）》（2012年）； （c）1992年12月8日的《比利时隐私法》； （d）《加拿大个人信息保护和电子文档法》，SC 2000，c 5（PIPEDA）； （e）《 2012年新加坡个人资料保护法》（PDPA）； （f）适用于数据当事人所在地的其他隐私和数据保护法律； （g）适用的任何后续法规。',
      title3:'我们何时收集您的个人数据？',
      title3Respects1:'在以下情况下，当您通过电话，电子邮件，网站或其他方式与我们通信时，Q-NEX可能会收集您的个人数据：',
      title3a:'浏览我们的网站或访问我们的社交媒体网站；',
      title3b:'与Q-NEX通讯；',
      title3c:'参观我们的办公室，活动或设施；',
      title3d:'注册/参加我们的会议，活动，培训或其他活动；',
      title3e:'要求提供信息，支持，服务，材料，协助或其他查询；',
      title3f:'订阅新闻通讯或其他邮件清单；',
      title3g:'交换名片；',
      title3h:'填写网站联系表，问卷，调查或竞赛报名表或以其他方式参加这些活动；',
      title3i:'从事商业关系或其他合作；',
      title3j:'订购或注册Q-NEX产品；',
      title3k:'创建或注册帐户；;',
      title3l:'上载或下载文件；',
      title3m:'V验证您作为数据主体的身份；',
      title3n:'使用连接到Internet的Q-NEX产品，包括移动应用程序，云平台和某些硬件设备。',
      title4:'我们收集哪些类型的个人数据？',
      title4Respects1:'Q-NEX可能会收集以下个人数据：',
      title4a:'姓名，姓氏，职称，公司，电子邮件地址，电话号码（手机和座机），地址，签名和其他联系信息；',
      title4b:'IP地址；',
      title4c:'位置数据；',
      title4d:'Cookie ID；',
      title4e:'语言；',
      title4f:'关于通讯/产品和服务的个人偏好；',
      title4g:'财务详细信息（例如付款信息，银行帐号和信用信息）；',
      title4h:'有关使用Q-NEX产品和服务的项目的个人数据；',
      title4i:'您提交，回应和反馈中提供的个人数据；',
      title4j:'有关您与Q-NEX互动的个人数据，包括您对网站和Q-NEX产品或服务的使用；',
      title4k:'社交媒体数据，图像，照片和照相机镜头；',
      title4l:'您或您的Q-NEX授权经销商或服务提供商提供的任何其他个人数据。',
      title4Respects2:'为避免疑义，Q-NEX不会收集任何敏感的个人数据，例如种族或民族血统；政治观点；宗教或哲学信仰；遗传特征健康信息；性偏好；有关儿童的信息；刑事定罪;或生物识别数据，我们明确要求您不要在您对我们的回应或反馈中向我们提供此类数据。',
      title5:'我们如何使用您的个人数据？',
      title5Respects1:'为了更好地管理我们自己的业务需求并更好地与您沟通，我们可能出于以下目的收集，分析，使用和处理您的个人数据：',
      title5a:'答复您的询问，问题和其他要求；',
      title5b:'优化和管理我们网站的质量和内容，包括个性化和保护您的网站体验的能力；',
      title5c:'创建和维护您的网站，客户和产品账户以及注册；',
      title5d:'为您提供营销，广告，促销，计划，优惠和其他机会；包括时事通讯，有关产品和服务的信息，订阅，培训，更新和直接营销（可能根据您的通信偏好而有针对性）；',
      title5e:'进行顾客满意度研究，调查和其他市场研究；',
      title5f:'管理我们的活动和活动，并邀请您参加活动；',
      title5g:'注册来访我们办公室，设施和活动的访客；',
      title5h:'制作宣传材料，包括有关项目或活动的视频，照片，文章，案例研究，新闻通讯和其他材料；',
      title5i:'提供产品，服务，培训，技术支持，客户服务和其他协助；',
      title5j:'管理和履行我们的协议和义务；',
      title5k:'对业务线索，机会和联系做出响应并采取后续行动；',
      title5l:'处理付款，订单，发票，退货，托收和其他要求；',
      title5m:'提供我们产品和服务的价格，报价和定制配置；',
      title5n:'授权您访问我们的软件，培训，技术信息和其他专有内容；',
      title5o:'评估，故障排除，分析和改善我们产品，服务，培训，技术支持和客户服务的使用，功能，功能和性能；',
      title5p:'收集，分析和维护有关我们产品和服务的配置和备份数据；',
      title5q:'促进有关我们的产品和服务的计划，分析，预测和报告；',
      title5r:'用于我们的内部业务运营和流程，包括业务和财务记录保存，数据管理和业务连续性；',
      title5s:'履行我们的法律和法规义务。',
      title6:'哪种法律依据适用于我们处理您的个人数据？',
      title6Respects1:'为了上述目的，以下法律依据可能适用于您的个人数据处理：',
      title6a:'为履行您与我们之间的协议或采取所有合同前步骤，必须进行处理；',
      title6b:'处理是基于我们的合法利益（遵守义务，维护业务记录，防止欺诈，网络和信息安全等）进行的。在进行此类处理时，我们力求在这种合法利益与尊重您的隐私之间取得平衡。',
      title6c:'您已同意处理（例如，在直接营销的情况下，用于处理分析Cookie以及将数据传输给第三方）；',
      title6d:'为了使我们遵守我们的法律义务（例如税务管理和记录保留）；要么',
      title6e:'在非常特殊的情况下保护您或他人的切身利益。',
      titel7:'我们向谁披露您的个人数据？',
      title7Respects1:'Q-NEX可能向您自己，Q-NEX的关联公司或第三方披露您的个人数据，例如支付提供商，软件提供商，合作伙伴，运输合作伙伴，金融机构，保险公司，法律服务或某些其他服务提供商或与Q-NEX建立战略关系的合作伙伴，以便以最有效的方式实现我们与您的关系。',
      title7Respects2:'Q-NEX不会将您出于本隐私政策中所述目的以外的目的提交的任何个人数据透露给第三方。如果将来我们打算出于除本隐私政策所述目的以外的任何目的向第三方披露您的个人数据，我们将提前通知您，并在需要时征得您的同意。',
      title7Respects3:'尽管有上述规定，在法律要求下、在法律程序中，或如出于善意，Q-NEX认为您有必要采取行动以遵从法规，Q-NEX将向第三方（例如主管当局）披露您的个人数据遵守某些法律，法规或规章。',
      titel8:'如果进行国际数据传输，我们提供哪些保证？',
      title8Respects1:'Q-NEX是一家全球性公司，我们可能会将您的信息转移给代表我们在全球范围内的Q-NEX分支机构，代表或第三方承包商。每个分支机构，代表或第三方承包商都与Q-NEX密切合作，这些关联实体之间的任何个人数据传输都将遵守适用的隐私和数据保护法。',
      title8Respects2:'如果将欧洲经济区（EEA）居民的个人数据转移给位于EEA以外国家/地区的个人或实体时，被认为未提供足够的保护，我们将制定信息安全性更强，更适当的合同条款以加强数据保护。为确保对EEA居民个人数据的任何此类传输均符合适用的《隐私和数据保护法》，我们将（i）根据欧盟示范协议签订数据传输协议，（ii）采用具有约束力的公司规则，（iii）依靠法律确定的例外情况（例如请求您的明确同意），或（iv）采用被认为可以为您的个人数据提供充分保护的其他机制。',
      titel9:'我们如何保护您的个人数据？',
      title9Respects1:'根据行业标准，我们使用各种安全技术和预防措施，例如安全套接字（SSL）协议（加密），以帮助保护您的个人数据免于丢失，被盗，滥用和未经授权的访问。 为了保护存储在Q-NEX服务器或基于云的存储上的任何个人数据，我们会定期监视我们的系统是否存在漏洞或攻击，并实施最新的信息安全措施。',
      title9Respects2:'Q-NEX处理的个人数据的访问仅限于需要了解该信息以及代表Q-NEX根据本隐私政策处理该信息的员工，承包商和下属组织，并且未同意透露给他人。',
      titel10:'我们将保留您的个人数据多长时间？',
      title10Respects1:'除非法律要求更长的保留期，否则Q-NEX将在实现本隐私政策中所述的相关目的的期间保留您的个人数据。',
      titel11:'Cookies的使用',
      title11Respects1:'Q-NEX在我们的网站上使用cookie，既可以使网站正常工作，又可以改善您访问我们网站时的体验。 Cookie文件存储在您计算机的硬盘驱动器上，使我们能够获取有关您对我们网站使用情况的信息，以及衡量和改善我们网站的性能。 Cookies使您能够存储您的首选项，以使我们的网站在您浏览我们的网站时能够识别这些首选项。',
      title11Respects2:'您可以通过激活浏览器上允许您拒绝cookie的设置来拒绝接受cookie。但是，如果选择此设置，则可能无法访问我们网站的某些部分或功能。除非您已调整浏览器设置以使其拒绝Cookie，否则您每次登录我们的网站时，我们的系统都会向您的计算机发布Cookie。',
      title11Respects3:'首次访问我们的网站时，您会获得此cookie政策的链接，并有机会更改浏览器设置以拒绝cookie。在不更改设置的情况下继续浏览我们的网站，即表示您同意我们按照本政策中的说明使用Cookie。',
      title11Respects4GoogleAnalytics:'Google Analytics。',
      title11Respects4:'我们使用行业标准的网络分析来跟踪对我们网站的访问，即Google Analytics（分析）提供的访问。 Cookies生成的有关您使用我们网站的信息（包括您的IP地址）将传输到Google Analytics（分析）并存储在其服务器上，并根据Google的隐私权政策进行处理，可通过以下链接访问：https： //policies.google.com/privacy。',
      titel12:'我们网站上的第三方链接',
      title12Respects1:'Q-NEX网站包含其他网站的链接。 Q-NEX对其他网站的隐私政策或其存储，使用或分发信息的方式不承担任何责任。 Q-NEX鼓励您查看您可能访问的任何网站的隐私政策。',
      titel13:'儿童信息',
      title13Respects1:'Q-NEX的网站不适合儿童使用，其产品和服务也不出售给儿童。 根据《儿童个人信息网络保护规定》，我们不会从已知的18岁以下人士那里收集或维护信息，并且本网站的任何部分均不旨在吸引18岁以下的任何人。',
      titel14:'您的权利是什么？如何行使这些权利？',
      title14Respects1:'如果您是自然人，则您有权随时获知我们处理的有关您的个人数据，并在适用的《电信和互联网用户个人信息保护规定》授权的范围内，有权要求访问，修改，限制使用，个人信息的传输，删除或反对处理您的个人数据，但以适用的隐私和数据保护法为准。',
      title14Respects2:'如果处理完全基于您的同意，那么您也有权随时撤回您的同意，而不会影响撤销前处理的合法性。',
      title14Respects3:'通过以下列出的联系方式，您可以对Q-NEX处理您的个人数据行使上述权利，除非这需要Q-NEX做出超格的努力。',
      title14Respects4:'如果您对个人数据或行使上述权利有任何其他疑问，请随时使用下面列出的联系信息，我们将竭诚为您服务。',
      title14Respects5:'如果您与我们联系以行使适用的隐私和数据保护法中的一项权利，我们将在一（1）个月内答复。在某些特殊情况下，我们最多可能需要三（3）个月才能完全答复您，但在这种情况下，我们会在最初答复中告知您为什么我们需要更多时间来答复。',
      title14Respects6:'如果我们无法解决查询或请求，则您可能有权向当地数据保护机构投诉。',
      titel15:'随时了解我们的隐私政策的变化',
      title15Respects1:'在技术和法规不断变化的世界中，本隐私政策也可能会发生变化。 我们邀请您始终查阅https://www.qnextech.com/legal上发布的本政策的最新版本，如果有任何更改，我们将通过我们的网站或其他常用通信渠道通知您。',
      titel16:'联系Q-NEX',
      title16Respects1:'如果您对此隐私政策或Q-NEX收集，使用/处理您的个人数据的方式有疑问/评论，请与我们联系：',
      title16Respects2:'通过电子邮件：info@qnextech.com',

  },
  guidepages:{
    next:'下一步-控制设备',
    next1:'下一步-控制设备',
    next2:'下一步-广播控制',
    next3:'下一步-开始广播',
    next4:'下一步-停止广播',
    next5:'下一步-文字广播',
    next6:'下一步-任务设置',
    next7:'下一步-创建任务',
    next8:'下一步-历史清单',
    next9:'下一步-云盘管理',
    next10:'下一步-直播控制',
    next11:'下一步-设置直播',
    exit:'退出指引',
    guideContent:'指引目录',
    btnHomepage:'首页',
    btnDevices:'设备控制',
    btnBroadcast:'广播控制',
    btnSchedule:'任务控制',
    btnResources:'存储管理',
    btnStreaming:'直播管理',
    btnPrevious:'上一步'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js